import { Component, lazy, Suspense, useEffect, useState } from "react";
import { visualizacao3dDoItem, prepararArquivo3d } from "../utils/visualizacao3d";
import "./Visualizador3D.css";
const Cena3D = lazy(() => import("./Cena3D"));

export function Visualizador3D({ modelo, nome, inicialmenteAberto = false }) {
  const validado = visualizacao3dDoItem({ visualizacao3d: modelo });
  if (!validado) return null;
  // Chave só pela url: remonta (e fecha o painel) quando troca de arquivo,
  // mas não a cada vez que a seleção de placas muda (ex.: Configurar3D
  // marcando/desmarcando checkboxes com o painel aberto).
  return <Painel3D key={validado.url} modelo={validado} nome={nome} inicialmenteAberto={inicialmenteAberto} />;
}
class ErroVisualizador extends Component {
  state = { erro: false };
  static getDerivedStateFromError() { return { erro: true }; }
  render() {
    return this.state.erro
      ? <p role="alert">Não foi possível carregar o visualizador. Atualize a página e tente novamente.</p>
      : this.props.children;
  }
}
function Painel3D({ modelo, nome, inicialmenteAberto }) {
  const [aberto, setAberto] = useState(inicialmenteAberto);
  const [escolhida, setPlaca] = useState("todas");
  const [resolvido, setResolvido] = useState(null);
  const [erro, setErro] = useState("");
  const [tentativa, setTentativa] = useState(0);
  useEffect(() => {
    if (!aberto || !modelo.automatica || resolvido) return;
    const controller = new AbortController();
    let ativo = true;
    setErro("");
    (async () => {
      try {
        const res = await fetch(modelo.url, { signal: controller.signal });
        if (!res.ok) throw new Error("Não foi possível baixar o modelo.");
        const dados = await res.arrayBuffer();
        const arquivo = await prepararArquivo3d(dados, { url: modelo.url, nome: modelo.nome });
        if (!arquivo.placasSelecionadas?.length) throw new Error("Prévia 3D indisponível para este produto.");
        if (ativo) setResolvido({ placas: arquivo.placasSelecionadas, dados });
      } catch (e) { if (ativo) setErro(e.message); }
    })();
    return () => { ativo = false; controller.abort(); };
  }, [aberto, modelo.automatica, modelo.url, modelo.nome, resolvido, tentativa]);
  const placas = modelo.automatica ? resolvido?.placas : modelo.placas;
  const placa = escolhida === "todas" || placas?.includes(Number(escolhida)) ? escolhida : "todas";
  return <section className="viewer3d" aria-label={"Visualização 3D de " + (nome || "produto")}>
    <button type="button" className="viewer3d-open" aria-expanded={aberto} onClick={() => setAberto(v => !v)}>
      {aberto ? "Fechar visualização 3D" : "◇ Ver em 3D"}
    </button>
    {aberto && <>
      {!placas && !erro && <p role="status">Preparando modelo 3D…</p>}
      {erro && <p role="alert">{erro} <button type="button" onClick={() => setTentativa(t => t + 1)}>Tentar novamente</button></p>}
      {placas?.length > 0 && <>
        <div className="viewer3d-toolbar">
          <strong>{nome || "Modelo 3D"}</strong>
          {placas.length > 1 ? <label>Placa{" "}
            <select aria-label="Placa exibida" value={placa} onChange={e => setPlaca(e.target.value)}>
              <option value="todas">Todas as selecionadas</option>
              {placas.map(p => <option key={p} value={p}>Placa {p}</option>)}
            </select>
          </label> : /\.3mf$/i.test(modelo.nome) && <span>Placa {placas[0]}</span>}
        </div>
        <ErroVisualizador><Suspense fallback={<p role="status">Preparando visualizador…</p>}>
          <Cena3D url={modelo.url} placas={placa === "todas" ? placas : [Number(placa)]} nome={nome} arquivoNome={modelo.nome} dados={resolvido?.dados} />
        </Suspense></ErroVisualizador>
        <p className="viewer3d-hint">Arraste para girar. Role para aproximar. Use o botão direito ou dois dedos para mover.</p>
        <p className="viewer3d-hint">Prévia do modelo nas placas selecionadas. Cores e recortes podem variar na impressão.</p>
      </>}
    </>}
  </section>;
}
